module.exports = __webpack_public_path__ + "img/Impala2.5045fd7c.png";